<template>
    <div class="homepage-3 inner">
        <ScrollupSection />
        <div class="main">
            <HeaderSection />
            <section id="home" class="section welcome-area inner-area bg-overlay h-100vh overflow-hidden">
                <div class="container h-100">
                    <div class="row align-items-center justify-content-center h-100">
                        <div class="col-12 col-md-7">
                            <div class="welcome-intro text-center">
                                <h1 class="text-white">Stay Tuned!</h1>
                                <p class="text-white my-4">About once a month, we release a newsletter explaining all the latest updates about our platform. If you enter your email, we'll send you a copy until you unsubscribe (a link is at the bottom of each newsletter).</p>
                                <!-- Subscribe Form -->
                                <div class="subscribe-form d-flex align-items-center mx-auto">
                                    <input type="email" class="form-control" placeholder="Enter your Email">
                                    <button type="submit" class="btn btn-bordered">Subscribe</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>

<script>
import ScrollupSection from '../../ScrollupSection/scrollUp'
import HeaderSection from '../../HeaderSection/headerOne'

export default {
    name: 'Newsletter',
    components: {
        ScrollupSection,
        HeaderSection
    }
}
</script>

<style>

</style>